"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var _a;
exports.__esModule = true;
exports.multiReferenceTypeConfigSchema = exports.referenceTypeConfigSchema = exports.genericFieldTypeConfigSchema = void 0;
var wix_data_schema_types_1 = require("@wix/wix-data-schema-types");
var validate_1 = require("./utils/validate");
var genericFieldTypeConfigSchema = {
    type: validate_1.optional(validate_1.string),
    displayName: validate_1.optional(validate_1.string),
    calculator: validate_1.optional(validate_1.objectProperties({
        id: validate_1.string,
        config: validate_1.objectProperties({
            pattern: validate_1.string,
            lowercase: validate_1.optional(validate_1.boolean)
        })
    })),
    pluginId: validate_1.optional(validate_1.string),
    plugin: validate_1.optional(validate_1.string),
    queryOperators: validate_1.optional(validate_1.list(validate_1.string)),
    systemField: validate_1.optional(validate_1.boolean),
    sortable: validate_1.optional(validate_1.boolean),
    isDeleted: validate_1.optional(validate_1.boolean),
    pii: validate_1.optional(validate_1.boolean)
};
exports.genericFieldTypeConfigSchema = genericFieldTypeConfigSchema;
var referenceTypeConfigSchema = __assign({ referencedCollection: validate_1.string }, genericFieldTypeConfigSchema);
exports.referenceTypeConfigSchema = referenceTypeConfigSchema;
var multiReferenceTypeConfigSchema = __assign({ referencingFieldKey: validate_1.string, referencingDisplayName: validate_1.string }, referenceTypeConfigSchema);
exports.multiReferenceTypeConfigSchema = multiReferenceTypeConfigSchema;
exports["default"] = (_a = {
        "default": genericFieldTypeConfigSchema
    },
    _a[wix_data_schema_types_1.FieldType.reference] = referenceTypeConfigSchema,
    _a[wix_data_schema_types_1.FieldType.multiReference] = multiReferenceTypeConfigSchema,
    _a);
//# sourceMappingURL=fieldConfigSchemas.js.map